/** Contorno da estrela (viewBox 24×24) — compartilhado pelas telas de avaliação. */
export const CAMINHO_ESTRELA =
  'M12 1.8l3.09 6.26 6.91 1-5 4.87 1.18 6.88L12 17.56l-6.18 3.25L7 13.93 2 9.06l6.91-1z';

type Props = {
  nota: number;
  /** Lado em px. O número escala junto (fica legível a partir de ~22px). */
  tamanho?: number;
  className?: string;
};

/**
 * Estrela dourada com a nota (1–5) escrita dentro. Decorativa: quem usa
 * descreve a nota no rótulo acessível do elemento em volta.
 */
export function EstrelaNota({ nota, tamanho = 56, className }: Props) {
  // Em tamanhos pequenos o número precisa ocupar mais da estrela para ser lido.
  const fonte = tamanho < 36 ? 9.5 : 7.5;
  return (
    <svg
      className={`estrela-nota${className ? ` ${className}` : ''}`}
      viewBox="0 0 24 24"
      width={tamanho}
      height={tamanho}
      aria-hidden="true"
      focusable="false"
    >
      <path d={CAMINHO_ESTRELA} />
      <text x="12" y="13.8" textAnchor="middle" dominantBaseline="middle" fontSize={fonte}>
        {nota}
      </text>
    </svg>
  );
}

/** Cinco estrelas em linha, preenchidas até a nota. */
export function EstrelasLinha({ nota, tamanho = 22 }: { nota: number; tamanho?: number }) {
  return (
    <span className="estrelas-linha" role="img" aria-label={`${nota} de 5 estrelas`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <svg
          key={n}
          viewBox="0 0 24 24"
          width={tamanho}
          height={tamanho}
          className={n <= nota ? 'estrelas-linha__item estrelas-linha__item--cheia' : 'estrelas-linha__item'}
          aria-hidden="true"
          focusable="false"
        >
          <path d={CAMINHO_ESTRELA} />
        </svg>
      ))}
    </span>
  );
}
